import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Redux slices
import { setActivePage, setUser, setToken, openModal, setContractId } from '../../appSlice';
import { resetObject, showObjectSidebar, hideObjectSidebar } from '../object/objectSlice';
import { showSidebar, hideSidebar, setContractIsLoaded, setContractData } from '../contract/contractSlice';
import { setWatchlist, setLastObjects } from '../dashboard/dashboardSlice';
import { setSubPage, setSubPage2 } from './menuSlice';

// Components
import Max2ObjectSubmenu from '../object/submenu';
import Max2ContractSubmenu from '../contract/submenu';

// Semantic UI components
import { Button, Icon, Dropdown, DropdownMenu, DropdownItem, Menu, MenuItem, MenuMenu, Breadcrumb, BreadcrumbSection, BreadcrumbDivider } from 'semantic-ui-react';

// Styles
import 'semantic-ui-css/semantic.min.css';


const Max2Menu = () => {
  // global state
  const dispatch = useDispatch();
  const aktivePage      = useSelector((state) => state.app.activePage);
  const subPage         = useSelector((state) => state.menu.subPage);
  const subPage2        = useSelector((state) => state.menu.subPage2);

  const object          = useSelector((state) => state.object.data);
  const objectId        = useSelector((state) => state.app.objectId);
  const isObjectSidebar = useSelector((state) => state.object.isSidebar);

  const isSidebar       = useSelector((state) => state.contract.isSidebar);

  const userDetails     = useSelector((state) => state.app.user);
  const backendUrl      = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  // defaults
  let breadcrumb = <></>;
  let submenu = <></>;
  let closeButton = <></>;


  /**
   * 
   */
  const handleLogOut = () => {
    fetch(backendUrl + '/user/logout', { credentials: 'include' })
      .then(response => response.json())
      .then(() => {
        console.log('Erfolgreich ausgeloggt');
        dispatch(setWatchlist(null));
        dispatch(setLastObjects(null));
        dispatch(setActivePage('START'));
        dispatch(setUser(null));
        dispatch(setToken(null));
      });
  }



  /**
   * 
   */
  const handleDashboardClick = () => {
    dispatch(setWatchlist(null));
    dispatch(setLastObjects(null));
    dispatch(setActivePage('DASHBOARD'));

    dispatch(setSubPage(''));
    dispatch(setSubPage2(''));
  }



  /**
   * 
   */
  const handleMenuClick = () => {
    dispatch(setActivePage('SETTINGS'))
    dispatch(setSubPage(''));
    dispatch(setSubPage2(''));
  }


  //
  switch (aktivePage) {
    case 'DASHBOARD': 
      breadcrumb = <Breadcrumb size='large'>
        <BreadcrumbSection link style={{color:'#444'}}>Eurowings Holidays MAX<sup>2</sup></BreadcrumbSection>
        <BreadcrumbDivider icon='right chevron' />
        <BreadcrumbSection active>Dashboard</BreadcrumbSection>
      </Breadcrumb>;
      break;


      
    case 'USER': 
      breadcrumb = <Breadcrumb size='large'>
        <BreadcrumbSection link style={{color:'#444'}}>Eurowings Holidays MAX<sup>2</sup></BreadcrumbSection>
        <BreadcrumbDivider icon='right chevron' />
        <BreadcrumbSection active>Benutzerverwaltung</BreadcrumbSection>
      </Breadcrumb>;
      break;



    case 'SETTINGS':
      if (subPage) {
        if (subPage2) {
          breadcrumb = <Breadcrumb size='large'>
            <BreadcrumbSection link style={{color:'#444'}} onClick={()=>dispatch(setActivePage('DASHBOARD'))}>Eurowings Holidays MAX<sup>2</sup></BreadcrumbSection>
            <BreadcrumbDivider icon='right chevron' />
            <BreadcrumbSection link style={{color:'#ccc'}}>Systemsteuerung</BreadcrumbSection>
            <BreadcrumbDivider icon='right chevron' />
            <BreadcrumbSection link style={{color:'#ccc'}}>{subPage}</BreadcrumbSection>
            <BreadcrumbDivider icon='right chevron' />
            <BreadcrumbSection active style={{color:'#fff'}}>{subPage2}</BreadcrumbSection>
          </Breadcrumb>;
        } else {
          breadcrumb = <Breadcrumb size='large'>
            <BreadcrumbSection link style={{color:'#444'}} onClick={()=>dispatch(setActivePage('DASHBOARD'))}>Eurowings Holidays MAX<sup>2</sup></BreadcrumbSection>
            <BreadcrumbDivider icon='right chevron' />
            <BreadcrumbSection link style={{color:'#ccc'}}>Systemsteuerung</BreadcrumbSection>
            <BreadcrumbDivider icon='right chevron' />
            <BreadcrumbSection active style={{color:'#fff'}}>{subPage}</BreadcrumbSection>
          </Breadcrumb>;
        }
      } else {
        breadcrumb = <Breadcrumb size='large'>
          <BreadcrumbSection link style={{color:'#444'}} onClick={()=>dispatch(setActivePage('DASHBOARD'))}>Eurowings Holidays MAX<sup>2</sup></BreadcrumbSection>
          <BreadcrumbDivider icon='right chevron' />
          <BreadcrumbSection active style={{color:'#fff'}}>Systemsteuerung</BreadcrumbSection>
        </Breadcrumb>;
        break;
      }
      break;
      


    case 'OBJECT': 
      const handleCloseObjectClick = () => {
        dispatch(resetObject(false))
        dispatch(setActivePage('DASHBOARD'));
        dispatch(hideSidebar());
      }
      const title = object?.Product?.Code ? object?.Product?.Code + (object?.Basics?.HotelName ? ' - ' + object?.Basics?.HotelName : '') : '';
      breadcrumb = <Breadcrumb size='large'>
        <BreadcrumbSection link style={{color:'#ccc'}}>Eurowings Holidays MAX<sup>2</sup></BreadcrumbSection>
        <BreadcrumbDivider icon='right chevron' />
        <BreadcrumbSection link style={{color:'#ccc'}}>Dashboard</BreadcrumbSection>
        <BreadcrumbDivider icon='right chevron' />
        <BreadcrumbSection active style={{color:'#fff'}}>{title}</BreadcrumbSection>
      </Breadcrumb>;
      closeButton = <MenuMenu position='right'><MenuItem><Button circular style={{fontSize: '0.75em', marginRight: '10px'}} onClick={() => handleCloseObjectClick()}><Icon name='times' /> Schließen</Button></MenuItem></MenuMenu>
      submenu = <Max2ObjectSubmenu />
      break;



    case 'CONTRACT':
      const handleCloseContractClick = () => {
        dispatch(setContractData({ target: 'ALL', value: null }))
        dispatch(setContractIsLoaded(false));
        dispatch(setContractId(null));
        if (objectId) {
          dispatch(setActivePage('OBJECT'));
        } else {
          dispatch(setActivePage('DASHBOARD'));
        }
        dispatch(hideSidebar());
      }
      breadcrumb = <Breadcrumb size='large'>
        <BreadcrumbSection link style={{color:'#ccc'}} onClick={()=>handleDashboardClick()}>Eurowings Holidays MAX<sup>2</sup></BreadcrumbSection>
        <BreadcrumbDivider icon='right chevron' />
        <BreadcrumbSection link style={{color:'#ccc'}} onClick={()=>handleDashboardClick()}>Dashboard</BreadcrumbSection>
        <BreadcrumbDivider icon='right chevron' />
        <BreadcrumbSection link style={{color:'#ccc'}}>{subPage}</BreadcrumbSection>
        <BreadcrumbDivider icon='right chevron' />
        <BreadcrumbSection active style={{color:'#fff'}}>{subPage2}</BreadcrumbSection>
      </Breadcrumb>;
      closeButton = <MenuMenu position='right'><MenuItem><Button circular style={{fontSize: '0.75em', marginRight: '10px'}} onClick={() => handleCloseContractClick()}><Icon name='times' /> Schließen</Button></MenuItem></MenuMenu>
      submenu = <Max2ContractSubmenu />
      break;

    case 'MEDIA':
      breadcrumb = <Breadcrumb size='large'>
        <BreadcrumbSection link style={{color:'#ccc'}} onClick={()=>handleDashboardClick()}>Eurowings Holidays MAX<sup>2</sup></BreadcrumbSection>
        <BreadcrumbDivider icon='right chevron' />
        <BreadcrumbSection link style={{color:'#ccc'}} onClick={()=>handleDashboardClick()}>Dashboard</BreadcrumbSection>
        <BreadcrumbDivider icon='right chevron' />
        <BreadcrumbSection link style={{color:'#fff'}}>Medien</BreadcrumbSection>
      </Breadcrumb>;
      break;

    default: breadcrumb = <></>;
  }


  return (
    <>
    <Menu borderless inverted color='blue' size='large' style={{borderRadius: '0px', borderBottom: '1px solid #ccc'}}>
      <MenuMenu position='left'>
        <Dropdown item icon='bars'>
          <DropdownMenu>
            <DropdownItem name='Dashboard'  onClick={()=>handleDashboardClick()}>Dashboard</DropdownItem>
            {/*<DropdownItem name='Media'      onClick={() => dispatch(setActivePage('MEDIA'))}>Medien</DropdownItem>*/}
            <DropdownItem name='Settings'   onClick={()=>handleMenuClick()}>Systemsteuerung</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </MenuMenu>
      <span style={{width: '100%', color: 'wheat', paddingTop: '10px', paddingLeft: '25px', textAlign: 'left'}}>
        {breadcrumb}
      </span>
      {closeButton}
      <MenuMenu position='right'>
        <Dropdown item icon='user'>
          <DropdownMenu>
            <DropdownItem onClick={()=>dispatch(openModal('about'))}>Über</DropdownItem>
            <DropdownItem onClick={()=>dispatch(openModal({type: 'profile', data: userDetails}))}>Profil</DropdownItem>
            <DropdownItem onClick={()=>handleLogOut()}>Logout</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        {aktivePage === 'CONTRACT' && (
          <MenuItem>
            <Icon link name='sidebar' onClick={() => {
              if (isSidebar) {
                dispatch(hideSidebar())
              } else {
                dispatch(showSidebar())
              }
            }} />
          </MenuItem>
        )}
        {aktivePage === 'OBJECT' && (
          <MenuItem>
            <Icon link name='sidebar' onClick={() => {
              if (isObjectSidebar) {
                dispatch(hideObjectSidebar())
              } else {
                dispatch(showObjectSidebar())
              }
            }} />
          </MenuItem>
        )}
      </MenuMenu>
    </Menu>
    {submenu}
    </>
  )
}

export default Max2Menu;